module.exports = __webpack_public_path__ + "img/ctrl-v-dagger-stub-+.5c530b54.svg";